import { render, staticRenderFns } from "./percentage.vue?vue&type=template&id=4c894232&"
import script from "./percentage.vue?vue&type=script&lang=js&"
export * from "./percentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports